module.exports = __webpack_public_path__ + "img/2kaccountoverview.05b990fa.png";